import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import React from "react";
import Footer from "../Footer";
import Header from "../Header";
import MiniFooter from "../MiniFooter";

const plans = [
  {
    name: "Free Trial",
    price: "Gratuit",
    period: "14 jours",
    description: "Découvrez Docuveritas sans engagement",
    features: [
      "50 recherches par mois",
      "10 questions IA par jour",
      "Accès base documentaire limitée",
      "Support par email",
    ],
    cta: "Commencer l'essai",
    popular: false,
  },
  {
    name: "Standard",
    price: "99€",
    period: "par mois",
    description: "Pour les professionnels individuels",
    features: [
      "Recherches illimitées",
      "100 questions IA par jour",
      "Accès complet base documentaire",
      "5 certifications par mois",
      "Alertes personnalisées",
      "Support prioritaire",
    ],
    cta: "Choisir ce plan",
    popular: true,
  },
  {
    name: "Premium",
    price: "299€",
    period: "par mois",
    description: "Pour les équipes et cabinets",
    features: [
      "Tout du plan Standard",
      "Questions IA illimitées",
      "Certifications illimitées",
      "Gestion d'équipe",
      "API access",
      "Support dédié 24/7",
      "Formation personnalisée",
    ],
    cta: "Choisir ce plan",
    popular: false,
  },
];

export default function Pricing() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <section id="pricing" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Choisissez votre plan
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Des tarifs transparents adaptés à vos besoins professionnels
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {plans.map((plan, index) => (
              <Card
                key={index}
                className={`relative rounded-2xl ${
                  plan.popular
                    ? "border-2 border-slate-500 shadow-xl scale-105"
                    : "border-2 border-gray-200 hover:border-slate-300"
                } transition-all duration-300`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-slate-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                      Plus populaire
                    </span>
                  </div>
                )}

                <CardHeader className="text-center pb-8">
                  <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                    {plan.name}
                  </CardTitle>
                  <div className="mb-4">
                    <span className="text-4xl font-bold text-slate-500">
                      {plan.price}
                    </span>
                    {plan.period && (
                      <span className="text-gray-600 ml-2">
                        / {plan.period}
                      </span>
                    )}
                  </div>
                  <p className="text-gray-600">{plan.description}</p>
                </CardHeader>

                <CardContent className="pt-0">
                  <ul className="space-y-4 mb-8">
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start">
                        <Check className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
                        <span className="text-gray-600">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Button
                    className={`w-full py-3 rounded-xl ${
                      plan.popular
                        ? "bg-slate-500 hover:bg-slate-600 text-white"
                        : "bg-white border-2 border-slate-500 text-slate-500 hover:bg-slate-50"
                    }`}
                  >
                    {plan.cta}
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-4">
              Besoin d'une solution sur mesure pour votre organisation ?
            </p>
            <Button
              variant="outline"
              className="border-slate-500 text-slate-500 hover:bg-slate-50 bg-transparent"
            >
              Contactez notre équipe
            </Button>
          </div>
        </div>
      </section>
      <MiniFooter />
      <Footer />
    </div>
  );
}
